var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState, useRef } from 'react';
import { LocalTrackPublication } from 'livekit-client';
import './style.scss';
const VideoElm = ({ track }) => {
    _react_refresh_temp_2();
    const ref = useRef(null);
    const [loaded, setLoaded] = useState(false);
    const [self, setSelf] = useState(false);
    useEffect(() => {
        var _a;
        if (track instanceof LocalTrackPublication) {
            setSelf(true);
        }
        const el = ref.current;
        if (el) {
            (_a = track.videoTrack) === null || _a === void 0 ? void 0 : _a.attach(el);
        }
        return () => {
            var _a;
            if (el) {
                (_a = track.videoTrack) === null || _a === void 0 ? void 0 : _a.detach(el);
            }
        };
    }, [track]);
    const onLoadedData = () => {
        setLoaded(true);
    };
    const fullScreen = () => {
        var _a;
        if (!document.fullscreenElement) {
            (_a = ref.current) === null || _a === void 0 ? void 0 : _a.requestFullscreen().catch((err) => {
                alert(`Error attempting to enable full-screen mode: ${err.message} (${err.name})`);
            });
        }
        else {
            document.exitFullscreen();
        }
    };
    return (_jsxs("div", { className: "screen-share-video relative", children: [!loaded ? (_jsx("div", { className: "loading flex justify-center", children: _jsxs("div", { className: "lds-ripple", children: [_jsx("div", { className: "border-secondaryColor" }), _jsx("div", { className: "border-secondaryColor" })] }) })) : null, _jsx("button", { className: "absolute z-[99] bottom-0 right-0 p-1 bg-black/50", onClick: fullScreen, children: _jsx("i", { className: "icon pnm-fullscreen text[20px] text-white" }) }), _jsx("video", { onLoadedData: onLoadedData, ref: ref, className: `video-player absolute ${self ? 'self-screen-share' : 'remote-screen-share'}` })] }));
};
_react_refresh_temp_1 = VideoElm;
$RefreshReg$(_react_refresh_temp_1, "VideoElm");
_react_refresh_temp_2(VideoElm, "6gcP8Fi6GGtoetsM0C63QhG+47Y=");
export default VideoElm;
